
import ByTypes from './logic/ByTypes';
export default ByTypes;
